import { createAmplitude } from '@outputinc/o-analytics'

const amplitudeKey = import.meta.env.VITE_OUTPUT_AMPLITUDE_KEY

const amplitudeClient = createAmplitude(amplitudeKey)

export { amplitudeClient }
